import { ProductsPage, MasterProduct } from '@techstyle/react-products';
import { normalize, denormalize } from '@techstyle/redux-core';

// returns an array of normalized products from products payload
export const normalizeProducts = productsPayload => {
  // normalize transforms data from snake_case to camelCase based on ProductsPage schema
  const { result, entities } = normalize(productsPayload, ProductsPage);
  // denormalize maps the normalize data with the schema and returns the data with it's original object structure
  return denormalize(result, ProductsPage, entities).products || [];
};

// returns a normalized product data, in case we need to normalize a single product
export const normalizeProduct = product => {
  const { result, entities } = normalize(product, MasterProduct);
  return denormalize(result, MasterProduct, entities);
};
